<div class="wrapper">
    <div class="tree">
        @if (koMatches.length > 0) {
            @for (match of koMatches; track match.id; let i = $index) {
                <div class="match-container" [style]="getPositionStyle(match.stage!, i)">
                    <div class="teams-info">
                        <div class="team-name-container">
                <span class="team-name" [class.team-eliminated]="match.matchFinished && match.team1Won">
                {{ match.team2?.name }}
                    @if (match.matchFinished && !match.team1Won && match.stage === 3) {
                        <mat-icon class="material-icons-outlined winner-icon" inline="true">emoji_events</mat-icon>
                    }
                </span>
                            @if (!match.team2DrinksCollected && match.table) {
                                <div class="get-your-drinks-info">Get your drinks!</div>
                            }

                        </div>
                        <div class="team-name-container">
                <span class="team-name" [class.team-eliminated]="match.matchFinished && !match.team1Won">
                {{ match.team1?.name }}
                    @if (match.matchFinished && match.team1Won && match.stage === 3) {
                        <mat-icon class="material-icons-outlined winner-icon" [inline]="true">emoji_events</mat-icon>
                    }
                </span>
                            @if (!match.team1DrinksCollected && match.table) {
                                <div class="get-your-drinks-info">Get your drinks!</div>
                            }
                        </div>
                    </div>
                    <div class="table-info">
                        @if (match.table) {
                            <span class="table">{{ match.table.name }}</span>
                        }
                        <mat-icon inline="true" class="live-circle"
                                  [class.activated]="match.table && match.team1DrinksCollected && match.team2DrinksCollected">
                            circle
                        </mat-icon>
                    </div>

                </div>
            }
        }


        @if (matchThirdPlace) {

            <h4 #text3rdPlace id="text-3rd-place" style="z-index: 999; position: absolute">Spiel um Platz 3:</h4>


            <div class="match-container match-3rd-place" id="match-3rd-place-container" #match3rdPlaceContainer>
                <div class="teams-info">
                    <div class="team-name-container">
                <span class="team-name"
                      [class.team-eliminated]="matchThirdPlace.matchFinished && !matchThirdPlace.team1Won">
                {{ matchThirdPlace.team1Name }}
                </span>
                        @if (!matchThirdPlace.team1DrinksCollected && matchThirdPlace.tableName) {
                            <div class="get-your-drinks-info">Get your drinks!</div>
                        }

                    </div>
                    <div class="team-name-container">
                <span class="team-name"
                      [class.team-eliminated]="matchThirdPlace.matchFinished && matchThirdPlace.team1Won">
                {{ matchThirdPlace.team2Name }}
                </span>
                        @if (!matchThirdPlace.team2DrinksCollected && matchThirdPlace.tableName) {
                            <div class="get-your-drinks-info">Get your drinks!</div>
                        }
                    </div>
                </div>
                <div class="table-info">
                    @if (matchThirdPlace.tableName) {
                        <span class="table">{{ matchThirdPlace.tableName }}</span>
                    }
                    <mat-icon inline="true" class="live-circle"
                              [class.activated]="matchThirdPlace.tableName && matchThirdPlace.team1DrinksCollected && matchThirdPlace.team2DrinksCollected">
                        circle
                    </mat-icon>
                </div>
            </div>
        }
    </div>
</div>

<div class="beerpong-headline">
    <h1>4. Beerpongturnier</h1>
    <img class="logo" src="https://www.klubpfeilheim.at/logo.svg" alt="Klub Pfeilheim"/>
</div>

